
import React, { useState } from 'react';
import './error-banner.css';

function ErrorBanner({ 
  message, 
  type = 'error', 
  dismissible = true, 
  onDismiss,
  onRetry,
  retryText = 'Retry',
  className = ''
}) {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`error-banner ${type} ${className}`}>
      <div className="error-content">
        <div className="error-icon">
          {type === 'error' && '⚠️'}
          {type === 'warning' && '⚠️'}
          {type === 'info' && 'ℹ️'}
          {type === 'success' && '✅'}
        </div>
        
        <div className="error-message">
          {message || 'An error occurred. Please try again.'}
        </div>
        
        <div className="error-actions">
          {onRetry && (
            <button 
              className="error-btn retry-btn"
              onClick={handleRetry}
              type="button"
            >
              {retryText}
            </button>
          )}
          
          {dismissible && (
            <button 
              className="error-btn dismiss-btn"
              onClick={handleDismiss}
              type="button"
              aria-label="Dismiss"
            >
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ErrorBanner;
